import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/reports/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { AdminViewService } from "src/app/framework/services/admin-view.service";

@Component({
  selector: "app-retailer-acquisition",
  templateUrl: "./retailer-acquisition.component.html",
  styleUrls: ["./retailer-acquisition.component.scss"],
  providers: [CurrencyPipe],
})
export class RetailerAcquisitionComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  @Input() reatileracquisition;
  @Input() summary;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;
  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;
  isButtonDisabled:boolean

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["reatileracquisition"]) {
      this.reatileracquisition = changes["reatileracquisition"].currentValue;
      this.rowData = this.reatileracquisition;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
   
   
    this.columnDefs = [
      {
        field: "validity",
        headerName: "Since (Date)",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "validitytime",
        headerName: "Since (Time)",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm:ss:a");
        },
      },
      { field: "accountType", headerName: "Account Type", width: 180 },
      {
        field: "retailerAccountNumber",
        headerName: "Account Number",
        width: 200,
      },
      {
        field: "salesDistributorAssigned",
        headerName: "Sales Person",
        width: 200,
      },
      { field: "businessName", headerName: "Business Name", width: 220 },
      { field: "storeName", headerName: "DBA", width: 180 },
      //need to check
      { field: "retailerName", headerName: "Owner Name", width: 180 },
      { field: "businessNumber", headerName: "Store Phone Number", width: 250 },
      {
        field: "retailerMobileNumber",
        headerName: "Retailer Mobile Number",
        width: 300,
      },
      //
      { field: "address1", headerName: "Address", width: 180 },
      { field: "city", headerName: "City", width: 130 },
      { field: "state", headerName: "State", width: 130 },
      { field: "emailId", headerName: "Email Id", width: 180 },
      { field: "retailerRatePlan", headerName: "Rate Plan", width: 180 },
      {
        field: "availableBalance",
        headerName: "Available Balance",
        width: 230,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "creditLimitAssigned",
        headerName: "Credit Limit Assigned",
        width: 290,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "transactionLimitAssigned",
        headerName: "Transaction Limit Assigned",
        width: 300,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      { field: "autoReloadStatus", headerName: "Auto Reload", width: 200 },
    ];
    //this.rowData = []
  }
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Retailer-Acquisitin.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if (cellParams && cellParams.column.colId === "validity") {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "validitytime") {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (
        (cellParams && cellParams.column.colId === "availableBalance") ||
        cellParams.column.colId === "creditLimitAssigned" ||
        cellParams.column.colId === "transactionLimitAssigned"
      ) {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }
  ngOnInit(): void {
    super.ngOnInit();

     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService
      .getreatileracquisitionSummary(params)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.summary = resData;
          this.reportsService
            .getreatileracquisition(params)
            .subscribe((res) => {
              let resData: any = res;
              if (resData.httpcode == 200) {
                resData = resData.data;
                this.setRowData(res["data"]);
                this.reatileracquisition = resData;
              }
            });
        }
      });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
